// Missing random question support (only specific quiz)
// Only radio type quiz support for now
// No other support for answer

<script>
export default {

  name: 'Quiz',

  props: {
    quizId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      quiz: null,
      answer: null,
      answered: false,
    };
  },

  created() {
    this.getQuiz(this.quizId);
  },

  methods: {
    getQuiz(id) {
      this.$http.get(`/question/${id}`).then((response) => {
        if (response.status !== 204) {
          this.quiz = response.data.data;
        }
      });
    },

    postQuiz(quiz, answer) {
      const params = {
        question: quiz.question_id,
        type: quiz.type,
        answer: answer,
      };

      return this.$http.post('/answer', params).then((response) => {
        return response.data;
      });
    },

    answerQuiz(quiz, answer) {
      this.postQuiz(quiz, answer).then(() => {
        this.answered = true;
      });
    },
  },

};
</script>
